import { useState } from "react";
import { Icons } from "@/components/Icons";
import { useTenant } from "@/lib/tenant";
import { alertDialog } from "@/lib/dialog";

export function OrgSwitcher() {
  const { current, available, switchTo } = useTenant();
  const [open, setOpen] = useState(false);
  return (
    <div className="org-switch" data-tour="tenant" onClick={() => setOpen((o) => !o)} style={{ position: "relative", cursor: "default" }}>
      <span className="o-mark">{current?.name?.[0] ?? "?"}</span>
      <span className="org-name">{current?.name ?? "Choose tenant"}</span>
      <Icons.ChevDown size={14} />
      {open && (
        <div style={{
          position: "absolute", top: "calc(100% + 6px)", right: 0,
          background: "var(--warm-card)", border: "1px solid var(--warm-border)",
          borderRadius: "var(--r-md)", boxShadow: "var(--shadow-lg)",
          minWidth: 220, padding: 4, zIndex: 30,
        }}>
          {available.length === 0 && (
            <div className="muted" style={{ padding: "10px 12px", fontSize: 12 }}>No tenants yet.</div>
          )}
          {available.map((t) => (
            <div key={t.id}
              onClick={(e) => {
                e.stopPropagation();
                setOpen(false);
                switchTo(t.id).catch((err) => void alertDialog(err instanceof Error ? err.message : "Couldn't switch organisation."));
              }}
              style={{
                padding: "8px 10px", borderRadius: 6, fontSize: 13,
                background: t.id === current?.id ? "var(--warm-canvas)" : "transparent",
              }}>
              {t.name}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
